import { render } from "./QueueDisplay.vue?vue&type=template&id=95ab3474&scoped=true"
import script from "./QueueDisplay.vue?vue&type=script&lang=js"
export * from "./QueueDisplay.vue?vue&type=script&lang=js"

import "./QueueDisplay.vue?vue&type=style&index=0&id=95ab3474&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95ab3474"]])

export default __exports__